var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40767 4.45762C10.5653 2.47311 13.4327 2.47311 14.5903 4.45763L21.6083 16.4884C22.7749 18.4883 21.3323 21 19.0169 21H4.98108C2.66571 21 1.22309 18.4883 2.38974 16.4884L9.40767 4.45762ZM12.999 9.99997C12.999 9.44768 12.5513 8.99997 11.999 8.99997C11.4467 8.99997 10.999 9.44768 10.999 9.99997V13C10.999 13.5523 11.4467 14 11.999 14C12.5513 14 12.999 13.5523 12.999 13V9.99997ZM11.999 15C11.4467 15 10.999 15.4477 10.999 16C10.999 16.5523 11.4467 17 11.999 17H12.009C12.5613 17 13.009 16.5523 13.009 16C13.009 15.4477 12.5613 15 12.009 15H11.999Z",
    fill: "#EB7100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d6ffe7a8062c715910dceaf4bbcf9e63.svg";
export { ForwardRef as ReactComponent };